import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export default function Create_goal() {
    const [selectStartDate, setSelectStartDate] = useState(new Date())
    const [selectEndDate, setSelectEndDate] = useState(new Date())
    const [listProjectArray, setListProjectArray] = useState([]);
    const [linkOptionType, setLinkOptionType] = useState('');
    const [linkedProjectID, setLinkedProjectId] = useState('')
    const [selectedProjectName, setSelectedProjectName] = useState('')
    const [linkedTaskID, setLinkedTaskId] = useState('')
    const [selectedTaskName, setSelectedTaskName] = useState('')
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [listProjectTaskArray, setListProjectTaskArrayy] = useState([]);
    const navigate = useNavigate();
    const [goalData, setGoalData] = useState({
        title: '',
        description: '',
        category: 'Sales',
        priority: 'Mid',
        status: 'Not Started',
        progress: 0,
    });

    useEffect(() => {
        var company_id = localStorage.getItem('mem_company_id');
        var obj = {
            companyId: company_id
        };

        fetch('getAllProjects.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // ✅ important
            .then(parsedResult => {
                try {
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]);
                    }
                } catch (e) {
                    console.error("Processing error:", e);
                    showAlert('Failed to load project data.');
                    setListProjectArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
                showAlert('Server error while fetching projects.');
                setListProjectArray([]);
            });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    const [milestones, setMilestones] = useState([]);
    const [showMilestoneBox, setShowMilestoneBox] = useState(false);

    const [newMilestone, setNewMilestone] = useState({
        title: '',
        description: '',
        due_date: new Date(),
        file: null
    });

    const handleGoalChange = (e) => {
        setGoalData({
            ...goalData,
            [e.target.name]: e.target.value
        });
    };



    const handleStartDateChange = (date) => {
        setSelectStartDate(date);
    }

    const handleEndDateChange = (date) => {
        setSelectEndDate(date);
    }


    const addMilestone = () => {

        if (!newMilestone.title) {
            alert("Milestone title required");
            return;
        }

        setMilestones([...milestones, newMilestone]);

        // Reset form
        setNewMilestone({
            title: '',
            description: '',
            due_date: new Date(),
            file: null
        });

    };

    const removeMilestone = (index) => {

        const updated = [...milestones];
        updated.splice(index, 1);

        setMilestones(updated);
    };


    const saveGoal = async () => {

        if (!goalData.title) {
            alert("Goal title required");
            return;
        }

        const userId = localStorage.getItem('member_id');
        const com_id = localStorage.getItem('mem_company_id');
        const member_name = localStorage.getItem('membername');

        console.log(com_id)

        if (!userId) {
            alert("Login expired");
            return;
        }

        const formData = new FormData();

        formData.append("user_id", userId);
        formData.append("company_id", com_id);
        formData.append("member_name", member_name);
        formData.append("project_id", linkedProjectID);
        formData.append("task_id", linkedTaskID);

        formData.append("goal", JSON.stringify({
            ...goalData,
            start_date: selectStartDate.toISOString().split('T')[0],
            end_date: selectEndDate.toISOString().split('T')[0]
        }));

        const formattedMilestones = milestones.map(m => ({
            ...m,
            due_date: m.due_date.toISOString().split('T')[0]
        }));

        formData.append("milestones", JSON.stringify(formattedMilestones));

        milestones.forEach((m) => {
            if (m.file) {
                formData.append("files[]", m.file);
            }
        });

        try {

            const res = await fetch("createGoal.php", {
                method: "POST",
                body: formData
            });

            const text = await res.text();
            //console.log("RAW RESPONSE:", text);

            const data = JSON.parse(text);

            if (data.success) {

                showAlert("Goal Created");


                localStorage.setItem('goal_id', data.goal_id);

                const hasProject = Boolean(linkedProjectID);
                const hasTask = Boolean(linkedTaskID);

                if (!hasProject && !hasTask) {
                    navigate('/goal_details');
                    return;
                }

                if (hasProject) {
                    sendNotifications('project', data.goal_id, linkedProjectID, goalData.title);
                } else if (hasTask) {
                    sendNotifications('task', data.goal_id, linkedTaskID, goalData.title);
                }

                // always navigate after action
                // navigate('/goal_details');



            } else {
                showAlert(data.message);
            }

        } catch (err) {
            console.error(err);
            showAlert("Server Error");
        }
    };


    function sendNotifications(type, goal_id, ref_id, purpose_name) {
        var company_id = localStorage.getItem('mem_company_id');
        var uniqueid = crypto.randomUUID();
        var creator_id = localStorage.getItem('member_id');
        var obj = {
            company_id: company_id,
            ref_id: ref_id,
            type: 'goal',
            creator_name: localStorage.getItem('membername'),
            purpose: 'New goal',
            purpose_name: purpose_name,
            project_id: linkedProjectID,
            task_id: linkedTaskID,
            goal_id: goal_id,
            project_name: selectedProjectName,
            task_name: selectedTaskName,
            unid: uniqueid,
            creator_id: creator_id
        }
        $.ajax({
            type: 'POST',
            url: 'add_notifications.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result)
                navigate('/goal_details');
            },
        });
    }


    function setLinkOption(opt) {
        setLinkOptionType(opt)
        if (opt == 'project') {
            setLinkedTaskId('');
            setSelectedTaskName('');
            $('#optionproject').css('display', 'block');
        } else if (opt == 'task') {
            setLinkedProjectId('');
            setSelectedProjectName('')
            $('#optionproject').css('display', 'block');
            $('#optiontask').css('display', 'block');
        } else if (opt == 'none') {
            setLinkedTaskId('');
            setSelectedTaskName('');
            setLinkedProjectId('');
            setSelectedProjectName('');
            $('#optionproject').css('display', 'none');
            $('#optiontask').css('display', 'none');
        }
    }

    const selectProjectId = (e) => {
        var trgval = e.target.value;
        var trgprojectname = e.target.options[e.target.selectedIndex].text;
        if (linkOptionType == 'project') {
            setLinkedProjectId(trgval);
            setSelectedProjectName(trgprojectname)
        } else if (linkOptionType == 'task') {
            getTaskListForProject(trgval);
        }

    }

    const selectTaskId = (e) => {
        var trgval = e.target.value;
        var trgtaskname = e.target.options[e.target.selectedIndex].text;
        setLinkedTaskId(trgval)
        setSelectedTaskName(trgtaskname);
    }

    function getTaskListForProject(proid) {
        var obj = {
            pro_id: proid
        }

        $.ajax({
            type: 'POST',
            url: 'getAllProjectTasks.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;
                if (res !== 'fail' && res !== '') {
                    var arr = res;
                    setListProjectTaskArrayy(arr);
                } else {
                    showAlert('Cannot found any task for this project.');
                    $('#norecord').css('display', 'block');
                }
            },
        });
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Create New Goal</h2>
                    <Link className='pull_right add_new_pro' to="/goals">View Goals</Link>
                </div>

                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_one_row'>
                        <div className='vl_dsh_two_third mt-50'>
                            <div className='vl_dsh_formnholder'>
                                <div className='formfield noborder autoheight normalview'>
                                    <label>Insert Goal Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={goalData.title}
                                        onChange={handleGoalChange}
                                    />
                                </div>
                                <div className='formfield noborder autoheight normalview'>
                                    <label>Insert Goal Description</label>
                                    <textarea className='nobackground blacktext' name="description" value={goalData.description} onChange={handleGoalChange}></textarea>
                                </div>
                                <div className='vl_dsh_one_half'>
                                    <div className='formfield noborder autoheight'>
                                        <label>Select Category</label>
                                        <select name="category" className='nobackground' value={goalData.category} onChange={handleGoalChange}>
                                            <option value="Sales">Sales</option>
                                            <option value="Development">Development</option>
                                            <option value="Marketing">Marketing</option>
                                            <option value="Finance">Finance</option>
                                            <option value="Personal">Personal</option>
                                            <option value="Operations">Operations</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='vl_dsh_one_half'>
                                    <div className='formfield noborder autoheight'>
                                        <label>Select Priority</label>
                                        <select name="priority" className='nobackground' value={goalData.priority} onChange={handleGoalChange}>
                                            <option value="Low">Low</option>
                                            <option value="Mid">Mid</option>
                                            <option value="High">High</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='vl_dsh_one_half'>
                                    <div className='formfield noborder autoheight'>
                                        <label>Select Start Date</label>
                                        <div className='date_holder_new nobackground nopadding normalview'>

                                            <DatePicker
                                                selected={selectStartDate}
                                                onChange={handleStartDateChange}
                                                dateFormat="yyyy-MM-dd"
                                                showYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"

                                                yearDropdownItemNumber={50}
                                                scrollableYearDropdown
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='vl_dsh_one_half'>
                                    <div className='formfield noborder autoheight'>
                                        <label>Select End Date</label>
                                        <div className='date_holder_new nobackground nopadding normalview'>

                                            <DatePicker
                                                selected={selectEndDate}
                                                onChange={handleEndDateChange}
                                                dateFormat="yyyy-MM-dd"
                                                showYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"

                                                yearDropdownItemNumber={50}
                                                scrollableYearDropdown
                                            />
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className='vl_dsh_one_third mt-50'>
                            <div className='vl_dsh_formnholder'>
                                <div className='vl_dsh_one_full'>

                                    <div className='formfield noborder autoheight normalview'>
                                        <label>Select Status</label>
                                        <select name="status" value={goalData.status} onChange={handleGoalChange}>
                                            <option value="not_started">Not Started</option>
                                            <option value="in_progress">In Progress</option>
                                            <option value="on_hold">On Hold</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>
                                </div>

                                <div className='vl_dsh_one_full'>
                                    <div className='formfield noborder autoheight mt-15'>
                                        <label>Progress</label>
                                        <input type="range" min='0' max="100" name="progress" value={goalData.progress} onChange={handleGoalChange} />
                                        <span className='ml-10'>{goalData.progress}%</span>
                                    </div>
                                </div>
                                <div className='vl_dsh_one_full mt-15'>
                                    <div className='formfield noborder autoheight mt-15'>
                                        <label>Link The Goal (Optional)</label>
                                        <input className='mr-5' type="radio" name="link_goal_to" value="project" onClick={() => { setLinkOption('project') }} />With a project
                                        <input className='mr-5 ml-10' type="radio" name="link_goal_to" value="Task" onClick={() => { setLinkOption('task') }} />With a task
                                        <input className='mr-5 ml-10' type="radio" name="link_goal_to" value="none" onClick={() => { setLinkOption('none') }} />Not now
                                    </div>
                                    <div className='vl_dsh_one_half mt-15 nodisplay linkedoptions' id="optionproject">
                                        <label>Select a project</label>
                                        <select name="selectproject" onChange={selectProjectId}>
                                            <option value="">Select a Project</option>
                                            {listProjectArray.map((project) => (
                                                <option key={project.primary_key} value={project.primary_key}>
                                                    {project.pro_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='vl_dsh_one_half mt-15 nodisplay linkedoptions' id="optiontask">

                                        <label>Select a Task</label>
                                        <select name="selecttask" onChange={selectTaskId}>
                                            <option value="">Select a task</option>
                                            {listProjectTaskArray.map((task) => (
                                                <option key={task.primary_key} value={task.primary_key}>
                                                    {task.taskname}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className='vl_dsh_one_full mt-30'>
                                    <h2
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowMilestoneBox(!showMilestoneBox)}
                                    >
                                        ➕ Add Milestone
                                    </h2>

                                    {showMilestoneBox && (

                                        <div className='milestone_box'>

                                            <div className='formfield noborder autoheight normalview mt-15'>
                                                <label>Milestone Title</label>
                                                <input
                                                    type="text"
                                                    value={newMilestone.title}
                                                    onChange={(e) =>
                                                        setNewMilestone({ ...newMilestone, title: e.target.value })
                                                    }
                                                />
                                            </div>

                                            <div className='formfield noborder autoheight normalview mt-15'>
                                                <label>Description</label>
                                                <textarea
                                                    value={newMilestone.description}
                                                    onChange={(e) =>
                                                        setNewMilestone({ ...newMilestone, description: e.target.value })
                                                    }
                                                />
                                            </div>

                                            <div className='formfield noborder autoheight normalview mt-15'>
                                                <label>Due Date</label>

                                                <DatePicker
                                                    selected={newMilestone.due_date}
                                                    onChange={(date) =>
                                                        setNewMilestone({ ...newMilestone, due_date: date })
                                                    }
                                                    dateFormat="yyyy-MM-dd"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    dropdownMode="select"

                                                    yearDropdownItemNumber={50}
                                                    scrollableYearDropdown
                                                />
                                            </div>

                                            <div className='formfield noborder autoheight mt-15 normalview'>
                                                <label>File</label>
                                                <input
                                                    type="file"
                                                    onChange={(e) =>
                                                        setNewMilestone({ ...newMilestone, file: e.target.files[0] })
                                                    }
                                                />
                                            </div>
                                            <div className='formfield noborder autoheight mt-15 normalview'>
                                                <button className='addMilestonebtn' onClick={addMilestone}>Add Milestone</button>
                                            </div>

                                        </div>
                                    )}
                                    {milestones.length > 0 && (
                                        <div className="milestone_list">

                                            <h4>Added Milestones</h4>

                                            {milestones.map((m, i) => (
                                                <div key={i} className="milestone_item">

                                                    <b>{m.title}</b>
                                                    <p>{m.description}</p>
                                                    <small>{m.due_date.toDateString()}</small>

                                                    <button className='ml-10' onClick={() => removeMilestone(i)}>❌</button>

                                                </div>
                                            ))}

                                        </div>
                                    )}


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='vl_dsh_one_row mt-30'>
                        <div className='vl_dsh_one_full'>
                            <div className='vl_dsh_buttonholder'>
                                <button className='pull_right mr-10' onClick={saveGoal}>Save</button>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
